module.exports = __webpack_public_path__ + "static/media/opensans-extrabold-webfont.5fea2732.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-extrabold-webfont.woff2
// module id = 1023
// module chunks = 0